import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import MarketUpperImage from '../../../common/MarketUpperImage';
import { useTicketImageStyles } from './styles';
import noPhoto from '../../../common/icons/defaultTicketProblem.jpg';

const TicketImage = ({ ...props }) => {
  const { isMkp, thumbnailImage } = props;
  const classes = useTicketImageStyles();
  return (
    <Box>
      {thumbnailImage !== 'no-photo' && (
        <MarketUpperImage isMkp={isMkp}>
          <img className={classes.image} src={thumbnailImage} />
        </MarketUpperImage>
      )}
      {thumbnailImage === 'no-photo' && (
        <img className={classes.image} src={noPhoto} />
      )}
    </Box>
  );
};

TicketImage.propTypes = {
  isMkp: PropTypes.bool,
  thumbnailImage: PropTypes.string,
};

export default TicketImage;
